<!-- Placeholder label when displayed as a button and not a link -->
<!-- labels not supported for form buttons in 4.0 -->
@if (lmParagraphLayoutInfo?.parentIsParagraphLayout && lmParagraphLayoutInfo?.hasVisibleLabels && !field.label) {
  <label class="label">&nbsp;</label>
}

<!-- in a column layout -->
@if (lmColumnLayoutInfo?.nbrColumns > 1 && !lmParagraphLayoutInfo?.parentIsParagraphLayout && !field.label) {
  <label
    lm-label
    [layoutField]="field"
    [layoutInfo]="layoutInfo"
    [lmColumnLayoutInfo]="lmColumnLayoutInfo"
    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
    >
    &nbsp;
  </label>
}

@switch (displayType) {
  <!-- DISPLAY AS BUTTON -->
  @case (layoutDisplayType.TEXT_BUTTON) {
    <!-- email button with out user defined icon -->
    @if (!iconUrl) {
      <button
        [attr.id]="id"
        soho-button="{{buttonType}}"
        [ngClass]="{'lm-data-view-button-has-data': (isDataViewFieldButton && dataViewFieldButtonHasData)}"
        [class]="buttonBackgroundClass"
        [attr.aria-describedby]="fieldDescriptionId"
        icon="{{buttonIcon}}"
        (click)="onClickEvent($event)"
        (keydown.control.enter)="onClickEvent($event)"
        (fieldEvent)="onFieldEvent($event)"
        (blur)="onFieldBlur($event)"
        lm-field-style [fieldStyle]="field?.fieldStyle" [recalculateStyles]="triggerValueChange | async"
        [disabled]="!valid"
        soho-alert
        soho-tooltip [content]="buttonTooltip"
      >{{triggerValueChange | async | formatMessageRule:true:layoutObject.title:model:specFields}}</button>
    }
    <ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
  }
  @case (layoutDisplayType.ICON_BUTTON) {
    <!-- email button with user defined icon -->
    @if (validSohoIcon) {
      <button
        [attr.id]="id"
        soho-button="{{buttonType}}"
        icon="{{buttonIcon}}"
        (click)="onClickEvent($event)"
        (keydown.control.enter)="onClickEvent($event)"
        (fieldEvent)="onFieldEvent($event)"
        (blur)="onFieldBlur($event)"
        [disabled]="!valid"
        [class.personalize-actionable]="personalize"
        [class]="buttonBackgroundClass"
        soho-alert
        soho-tooltip [content]="buttonTooltip"
        >
        <span>{{triggerValueChange | async | formatMessageRule:true:layoutObject.title:model:specFields}}</span>
      </button>
    }
    @if (!validSohoIcon) {
      <button
        [attr.id]="id"
        [ngClass]="{'lm-form-icon-button': !layoutObject.title, 'btn-secondary': layoutObject.title}"
        [style.background-image]="layoutObject.icon && !layoutObject.title ? 'url(' + layoutObject.iconUrl + ')' : null"
        (click)="onClickEvent($event)"
        (keydown.control.enter)="onClickEvent($event)"
        (fieldEvent)="onFieldEvent($event)"
        (blur)="onFieldBlur($event)"
        [disabled]="!valid"
        [class.personalize-actionable]="personalize"
        [class]="buttonBackgroundClass"
        soho-alert
        soho-tooltip [content]="buttonTooltip"
        >
        <!-- decorative image, alt can be left blank since it's contained in a button -->
        @if (layoutObject.title) {
          <img src="{{layoutObject.iconUrl}}}" alt=""/>
        }
        <span>{{triggerValueChange | async | formatMessageRule:true:layoutObject.title:model:specFields}}</span>
      </button>
    }
  }
  @case (layoutDisplayType.TEXT_MAIL_BUTTON) {
    <!-- email button with out user defined icon -->
    @if (!iconUrl) {
      <button
        [attr.id]="id"
        soho-button="{{buttonType}}"
        icon="{{buttonIcon}}"
        (click)="mailTo()"
        (fieldEvent)="onFieldEvent($event)"
        (blur)="onFieldBlur($event)"
        [disabled]="!valid"
        [class]="buttonBackgroundClass"
        soho-alert
        soho-tooltip [content]="buttonTooltip"
      >{{triggerValueChange | async | formatMessageRule:true:layoutObject.title:model:specFields}}</button>
    }
  }
  @case (layoutDisplayType.ICON_MAIL_BUTTON) {
    <!-- email button with user defined icon -->
    @if (iconUrl) {
      <button
        [attr.id]="id"
        soho-button="{{buttonType}}"
        icon="{{buttonIcon}}"
        (click)="mailTo()"
        (fieldEvent)="onFieldEvent($event)"
        (blur)="onFieldBlur($event)"
        [disabled]="!valid"
        [class.personalize-actionable]="personalize"
        [class]="buttonBackgroundClass"
        soho-alert
        soho-tooltip [content]="buttonTooltip"
        >
        <span>{{triggerValueChange | async | formatMessageRule:true:layoutObject.title:model:specFields}}</span>
      </button>
    }
  }
  <!-- DISPLAY AS LINK -->
  @case (layoutDisplayType.TEXT_LINK) {
    <div soho-button icon="buttonIcon">
      <lm-hyperlink
        [specFields]="specFields"
        [model]="model"
        [layoutObject]="layoutObject"
        [layoutInfo]="layoutInfo"
        (fieldEvent)="onFieldEvent($event)"
        (click)="fireInitialValueRule()"
        >
      </lm-hyperlink>
    </div>
  }
  <!-- display as tag -->
  @case (layoutDisplayType.TAG) {
    <a
      class="tag is-clickable"
      [attr.id]="id"
      [attr.tabindex]="isInAccessibilityMode ? 0 : null"
      [class.data]="true"
      [style.color]="!!tagStyle?.style?.color ? 'white' : null"
      [style.cursor]="valid ? 'pointer' : 'default'"
      soho-alert
      lm-field-style
      [fieldStyle]="tagStyle?.style"
      [isTag]="true"
      [recalculateStyles]="triggerValueChange | async"
      (click)="valid ? onClickEvent($event) : null"
      (fieldEvent)="onFieldEvent($event)"
      (blur)="onFieldBlur($event)"
      >
      <span>{{triggerValueChange | async | formatMessageRule:true:layoutObject.title:model:specFields}}</span>
      <span>
        <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
          <use xlink:href="#icon-caret-right"></use>
        </svg>
        <span class="audible"></span>
      </span>
    </a>
    <ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
  }
  @case (layoutDisplayType.MAIL_LINK) {
    <lm-hyperlink
      [specFields]="specFields"
      [model]="model"
      [layoutObject]="layoutObject"
      [layoutInfo]="layoutInfo"
      (fieldEvent)="onFieldEvent($event)"
      >
    </lm-hyperlink>
  }
}

<ng-template #mouseOverTextTemplate>
  @if (layoutObject.mouseOverText) {
    <lm-mouse-over-text
      [beforeShowTooltip]="displayMouseOverText"
    ></lm-mouse-over-text>
  }
</ng-template>

<span [attr.id]="fieldDescriptionId" class="audible">{{ (isFocused$ | async) ? fieldDescription : '' }}</span>